import React, { useState } from 'react';
import axios from 'axios'; // For HTTP requests
import './Upload.css'; // Import the CSS styling

const Upload = () => {
  const [selectedFile, setSelectedFile] = useState(null); // State to hold the selected file
  const [uploadStatus, setUploadStatus] = useState(''); // State to hold the upload status

  // Handle file selection
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  // Handle file upload
  const handleUpload = async () => {
    if (!selectedFile) {
      setUploadStatus('Please select a file to upload.');
      return;
    }

    const formData = new FormData(); // Using FormData to send the file
    formData.append('file', selectedFile); // Append the selected file

    try {
      // Replace 'YOUR_BACKEND_ENDPOINT' with the actual backend URL
      const response = await axios.post('https://supabase-hackthon.onrender.com/api/v1/uploadFile/upload', formData);

      if (response.status === 200) {
        setUploadStatus('File uploaded successfully!');
      }
      else if(response.status===400){
        setUploadStatus('This pdf is already uploaded')
      }
       else {
        setUploadStatus('Failed to upload the file.');
      }
    } catch (error) {
      console.error('Upload error:', error);
      setUploadStatus('An error occurred while uploading the file.');
    }
  };

  return (
    <div className="upload-container"> {/* Apply the container styling */}
      <h2>Upload PDF</h2>
      <input
        type="file"
        accept=".pdf"
        className="upload-input"
        onChange={handleFileChange}
      />
      <button
        onClick={handleUpload}
        className="upload-button"
      >
        Upload
      </button>
      <p className="upload-status">{uploadStatus}</p>
    </div>
  );
};

export default Upload;
